import { render, staticRenderFns } from "./wheatreceive.vue?vue&type=template&id=9634958e&scoped=true&"
import script from "./wheatreceive.vue?vue&type=script&lang=js&"
export * from "./wheatreceive.vue?vue&type=script&lang=js&"
import style0 from "./wheatreceive.vue?vue&type=style&index=0&id=9634958e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9634958e",
  null
  
)

export default component.exports